function convertCubicMileToCubicFoot(num) {
  let eq =
    "Converting " +
    num +
    " cubic mile to cubic foot: \n" +
    num +
    " * 147197952000 = ";
  let rep = num * 147197952000;
  return eq + rep.toFixed(2);
}

function convertCubicMileToCubicInch(num) {
  let eq =
    "Converting " +
    num +
    " cubic mile to cubic inch: \n" +
    num +
    " * 2.543580611e+14 = ";
  let rep = num * 2.543580611e+14;
  return eq + rep.toFixed(2);
}

function convertCubicMileToCubicMeter(num) {
  let eq =
    "Converting " +
    num +
    " cubic mile to cubic meter: \n" +
    num +
    " * 4168181825 = ";
  let rep = num * 4168181825;
  return eq + rep.toFixed(2);
}

function convertCubicMileToCubicYard(num) {
  let eq =
    "Converting " +
    num +
    " cubic mile to cubic yard: \n" +
    num +
    " * 5451776000 = ";
  let rep = num * 5451776000 ;
  return eq + rep.toFixed(2);
}

function convertCubicMileToLiter(num) {
  let eq =
    "Converting " +
    num +
    " cubic mile to liter: \n" +
    num +
    " * 4.168181825e+12 = ";
  let rep = num * 4.168181825e+12;
  return eq + rep.toFixed(2);
}

export {
  convertCubicMileToLiter,
  convertCubicMileToCubicYard,
  convertCubicMileToCubicMeter,
  convertCubicMileToCubicInch,
  convertCubicMileToCubicFoot
};
